<template>
  <router-link
    :to="{
      name: 'autoinformer.campaign.edit',
      params: { id: id, tutorial: !!this.$route.params.tutorial, from_scheme: true }
    }"
    class="link-back"
  >
    <img class="link-back__img" src="/img/icons/header/back.svg" alt="Стерлка назад" />

    {{ $t('shared.component.button.back') }}
  </router-link>
</template>

<script>
  export default {
    data: function () {
      return {
        id: 0
      };
    },
    created() {
      this.id = this.$route.params.id;
    }
  };
</script>

<style lang="scss" scoped>
  .link-back {
    padding: 0 15px;
    color: $success;
    &:hover {
      cursor: pointer;
      background-color: #586e82;
      text-decoration: none;
    }
    &__img {
      margin-right: 10px;
    }
  }
</style>
